import React from "react";
import { Link } from "@chakra-ui/react";

// Deliberately conservative about where a URL ends. Trailing punctuation is
// almost always the sentence's, not the link's — "see https://doi.org/10.1/x."
// ends in a full stop that is not part of the DOI. Brackets are excluded for
// the same reason, and a closing paren is only kept when the URL opened one.
const URL_RE = /(https?:\/\/[^\s<>"'\]}]+)/g;
const TRAILING = /[.,;:!?'"”’)\]]+$/;

const trim = (url) => {
  let clean = url;
  const cut = clean.match(TRAILING);
  if (cut) {
    const tail = cut[0];
    // "(see https://example.org/a_(b))" — keep a paren the URL itself opened.
    const balanced =
      tail === ")" &&
      (clean.match(/\(/g) || []).length === (clean.match(/\)/g) || []).length;
    if (!balanced) clean = clean.slice(0, clean.length - tail.length);
  }
  return clean;
};

/**
 * Plain text with its URLs turned into links.
 *
 * Returns an array of strings and elements rather than HTML, because post and
 * comment bodies are written by members and are not sanitised anywhere. Built
 * as nodes, a URL in someone's text can only ever become a link — never a
 * script, and never markup that escapes the paragraph it sits in.
 */
export function renderTextWithLinks(text) {
  const value = typeof text === "string" ? text : "";
  if (!value) return value;

  const parts = value.split(URL_RE);
  if (parts.length === 1) return value;

  return parts.map((part, i) => {
    // split() with one capture group puts the matches at the odd indices.
    if (i % 2 === 0) return part;
    const href = trim(part);
    const rest = part.slice(href.length);
    return (
      <React.Fragment key={i}>
        <Link
          href={href}
          isExternal
          rel="noopener noreferrer nofollow"
          color="gwbi.600"
          textDecoration="underline"
          wordBreak="break-word"
          onClick={(e) => e.stopPropagation()}
        >
          {href}
        </Link>
        {rest}
      </React.Fragment>
    );
  });
}

export default renderTextWithLinks;
